module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("transaction_biller_form", [["form",{"action":"","method":""},[["foreach",{"from":"","item":"field"},[["input",{"type":"hidden","name":"","value":""},[],[["field._key","name",true],["field","value",true]]]],[["added_fields","from",true]]]],[["submit_url","action",true],["form_method","method",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/conversation/attachTransaction.tpl
// module id = 724
// module chunks = 4